import { Markup } from "interweave";
import { React, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
// import CR7Mo from '../../../../Assets/Images/Souvenir/Icons/sorry.png';

const CR7Modal = (props) => {
  return (
    <>
      <Modal {...props} centered size="lm">
        <Modal.Body className="mODALcR7">
          <div className="mx-3 my-4">
            <h5 className="text-warning mb-4">Acquire product process</h5>
            <p className="text-light Cr7Text">
              <Markup content={props.data?.acquired_instruction} />
            </p>
          </div>

          <i
            className="fas fa-times-circle  top-right_cross text-warning btn"
            onClick={props.onHide}
          ></i>

          <center className="">
            <Button
              className="btn bg-dark Modal_btn-xa mb-3 text-light Call-btn-v mx-3"
              onClick={props.onHide}
            >
              Cancel
            </Button>

            <Link to={`/auction-apply/${props.id}`}>
              <Button className="btn bg-warning Modal_btn-xa mb-3 text-dark Call-btn-v mx-3">
                Continue
              </Button>
            </Link>
          </center>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CR7Modal;
